module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAAAXNSR0IArs4c6QAAAIpJREFUOE9jZCARMMLUJycnq8ydO/cOIf1gDSDFzMzMtxkYGCbMmjWrEJ8muA2pqamrGRkZQwhpgmtwcHBgUVVVXU5IE1wDyBnEaELRQIwmDA2ENGHVgE8TTg0gTQkJCRxsbGz3GRgYJH79+qW5YMGCG9SxAV9oURZKJMUDMYpBAUFeWiIrtRKbHwDKelYTc8UdxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/min-icon-right.png
// module id = AlRN
// module chunks = 1